import styled from '@emotion/styled';
import { Button } from '../../../components/Marketing/Button';
import {
  OL_COLOUR_BLACK_10,
  OL_COLOUR_KELP,
  OL_COLOUR_TOMAHTO,
  OL_COLOUR_BLACK_90,
} from '../../../components/Style/colours';
import { MIXIN_ANCHOR_BUTTON } from '../../../components/Style/mixins';

import { Table } from '../ManageUsers/styles';

export const Header = styled('div')({
  borderBottom: `solid 1px ${OL_COLOUR_BLACK_10}`,
  marginBottom: 18,
});

export const Heading = styled('h4')({
  fontWeight: 'bold',
});

export const BannerContainer = styled('div')({
  marginBottom: 20,
});

export const InputContainer = styled('div')({
  marginBottom: 26,
});

export const ActionsContainer = styled('div')({
  marginBottom: 26,
});

export const BannerLinkStyle = styled('a')({
  color: 'black',
});

export const NeedHelpLinkStyle = styled('a')({
  color: OL_COLOUR_KELP,
});

export const SelectErrorContainer = styled('div')({
  marginTop: 24,

  '&, a': {
    color: OL_COLOUR_TOMAHTO,
  },
});

export const StyledButton = styled(Button)({
  textDecoration: 'none !important', // needed because Table styled component taking precendence. TODO: Need to refactor <Button> -> extenal_link variant to enforce more specificity; wrap <a> in <div>?
});

export const ViewDetailsButton = styled('button')({
  ...MIXIN_ANCHOR_BUTTON,
});

export const StyledTable = styled(Table)({
  td: {
    color: OL_COLOUR_BLACK_90,
    fontWeight: 'normal',
  },
});

export const StyledModalTable = styled(StyledTable)({
  'tbody tr td:first-child': {
    fontWeight: 400,
  },

  'tbody tr:last-child td': {
    fontWeight: 600,
  },
});
